<template>
  <div></div>
</template>

<script>
import {ebus} from "@/vendor/ebus";
import {getGlobalValue, setGlobalKeyValue} from "@/util/globalState";
import store from "../store/store";

export default {
  name: "PushTrigger",
  created() {
    ebus.$on('triggerPushQuestion', (yesOrNo) => {
      this.askUser();
    });
    ebus.$on('cb-wantsAbholnotify', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        ebus.$emit('lazyRequestPush', true);
      }
    });
  },
  methods: {
    askUser() {
      let now = Date.now();
      let easer = this.$ls.get('askForPush');
      if (!easer || now - parseInt(easer) > 3 * 24 * 60 * 60 * 1000) {
        this.$ls.set('askForPush', now);
      } else {
        //eased
        return;
      }

      if (!store.getters.isKiosk) {
        ebus.$emit('showQuestion', {
          quest: 'Möchtest du über wichtige News und neue Coupons benachrichtigt werden?',
          yesLabel: 'Ja erlauben',
          noLabel: 'Nein danke',
          yesAction: null,
          cb: 'cb-wantsAbholnotify'
        });
      }

    },
  }
}
</script>

<style scoped>

</style>
